import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import ThemeBadge from './ThemeBadge';

const ThemeBadges: FC = () => {
  const { game } = useGameContext();
  const themes = game?.themes?.edges;
  return (
    <div className="inline-container gap-2">
      {themes?.map(({ node }) => <ThemeBadge key={node?.id} theme={node} />)}
    </div>
  );
};

export default ThemeBadges;
